var map = {
	"./Animasi.jpg": "06e9",
	"./DKV.jpg": "d3a8",
	"./Desain Grafika.jpg": "15b1",
	"./Produksi Grafika.jpg": "879a",
	"./RPL.jpg": "fd50",
	"./animasi-major.png": "e71b",
	"./desain-grafika-major.png": "c057",
	"./dkv-major.png": "0297",
	"./produksi-grafika-major.png": "6f1f",
	"./rpl-major.png": "fc3f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b917";